import { render, staticRenderFns } from "./RoomAbilityList.vue?vue&type=template&id=9601cc0a&"
import script from "./RoomAbilityList.vue?vue&type=script&lang=js&"
export * from "./RoomAbilityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports